import { render } from "./TabPlantVppControlForm.vue?vue&type=template&id=48184910&scoped=true"
import script from "./TabPlantVppControlForm.vue?vue&type=script&lang=js"
export * from "./TabPlantVppControlForm.vue?vue&type=script&lang=js"

import "./TabPlantVppControlForm.vue?vue&type=style&index=0&id=48184910&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48184910"]])

export default __exports__